module.exports = __webpack_public_path__ + "img/Lihtenštajn.31fd6080.png";